/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgramSchema } from './ProgramSchema';
import {
    ProgramSchemaFromJSON,
    ProgramSchemaFromJSONTyped,
    ProgramSchemaToJSON,
} from './ProgramSchema';

/**
 * 
 * @export
 * @interface OrganizationStaffListSchema
 */
export interface OrganizationStaffListSchema {
    /**
     * 
     * @type {number}
     * @memberof OrganizationStaffListSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationStaffListSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationStaffListSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStaffListSchema
     */
    name: string;
    /**
     * 
     * @type {ProgramSchema}
     * @memberof OrganizationStaffListSchema
     */
    activeProgram?: ProgramSchema;
}

/**
 * Check if a given object implements the OrganizationStaffListSchema interface.
 */
export function instanceOfOrganizationStaffListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function OrganizationStaffListSchemaFromJSON(json: any): OrganizationStaffListSchema {
    return OrganizationStaffListSchemaFromJSONTyped(json, false);
}

export function OrganizationStaffListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationStaffListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'activeProgram': !exists(json, 'active_program') ? undefined : ProgramSchemaFromJSON(json['active_program']),
    };
}

export function OrganizationStaffListSchemaToJSON(value?: OrganizationStaffListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'active_program': ProgramSchemaToJSON(value.activeProgram),
    };
}

